export default __webpack_public_path__ + "static/media/user.715121f7.png";